import { SORTING_KEYS } from '../constants/sortingKeys';

export const sortingOptions = (translator) => [
  {
    key: SORTING_KEYS.DEADLINE_SOONEST,
    text: translator('components.filterAndSorting.deadlineSoonest'),
  },
  {
    key: SORTING_KEYS.DEADLINE_LATEST,
    text: translator('components.filterAndSorting.deadlineLatest'),
  },
  {
    key: SORTING_KEYS.RELEASE_SOONEST,
    text: translator('components.filterAndSorting.releaseSoonest'),
  },
  {
    key: SORTING_KEYS.RELEASE_LATEST,
    text: translator('components.filterAndSorting.releaseLatest'),
  },
  {
    key: SORTING_KEYS.ALPHABETICAL,
    text: translator('components.filterAndSorting.alphabetical'),
  },
  {
    key: SORTING_KEYS.ALPHABETICAL_REVERSE,
    text: translator('components.filterAndSorting.alphabeticalReverse'),
  },
];

export const noSelectionKey = 'NONE';

export const showAllKleHierarchies = 0;
export const showSelectedKleHierarchies = 1;
export const showUnselectedKleHierarchies = 2;

export const filterAndSortingKeys = {
  subjectArea: 'subjectAreaFilter',
  cityArea: 'cityAreaFilter',
  hearingType: 'hearingTypeFilter',
  hearingStatus: 'hearingStatusFilter',
  hearingOwner: 'hearingOwnerFilter',
  userHearingRole: 'userHearingRoleFilter',
  title: 'titleFilter',
  sortingKey: 'sortingKey',
  subGroupNumber: 'subGroupNumberFilter',
  mainGroupNumber: 'mainGroupNumberFilter',
  isChosen: 'selectedKleNumbers',
};
